import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { Store, StoreModule } from '@ngrx/store';

import * as fromGoogleServicesActions from './store/google-services.actions';
import { GoogleServicesEffects } from './store/google-services.effects';
import { googleServicesReducer } from './store/google-services.reducer';

@NgModule({
    imports: [
        EffectsModule.forFeature([GoogleServicesEffects]),
        StoreModule.forFeature('google-services', googleServicesReducer),
    ],
})
export class GoogleServicesModule {
    constructor(
        private readonly store: Store
    ) {
        this.store.dispatch(fromGoogleServicesActions.Init());
    }
}
